/** Oturum gerektiren rotalar — 401 sonrası login'e yönlendirme yalnızca burada */
export function isProtectedAppPath(path: string): boolean {
  return (
    path.startsWith('/checkout') ||
    path.startsWith('/orders') ||
    path.startsWith('/admin')
  );
}
